import { lazy } from "react";

export const Dictionary = lazy(() => import("./dictionary"));
export { CURRENT_DICTIONARY_PATH } from "./dictionary-path";
